import { BigNumber, constants } from 'ethers';

export const NFT_VAULTS_STABILITY_FEE = 1;
export const DENOMINATOR = 10 ** 9;
export const MIN_MINT_BOB_AMOUNT = constants.WeiPerEther.div(100);
export const Q128 = BigNumber.from(2).pow(128);
export const Q96 = BigNumber.from(2).pow(96);
export const Q48 = BigNumber.from(2).pow(48);
